import React, { useEffect } from 'react';
import { useProductPreList } from './hooks/ProductPreList.hook';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';
import ProductPreListView from './views/ProductPreListView';

const ProductPreListController = () => {
  const searchFormData = useSelector((state) => state.searchFormData);
  const currencyData = useSelector((state) => state.currency);
  const location = useSelector((state) => state.location?.data);
  const isFromMexico = isMexico(location);
  const { isLoading, spacesDataFromBackend } = useProductPreList(
    searchFormData,
    currencyData,
    isFromMexico,
  );
  const navigate = useNavigate();
  if (searchFormData) {
    if (isLoading) {
      return <LoadingComponent loading={isLoading} />;
    } else {
      return (
        <ProductPreListView
          spacesDataFromBackend={spacesDataFromBackend}
          searchFormData={searchFormData}
        />
      );
    }
  } else {
    navigate('/');
  }
};

export default ProductPreListController;
